import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/authService';
import './LoginForm.css';

const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      setError(t('auth.enterCredentials', 'Please enter both email and password'));
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await authService.login({ email, password });
      navigate('/');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Login failed';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Pro Admin</h1>
          <p>Service Report Management System</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          {error && <div className="login-error">{error}</div>}

          <div className="form-field">
            <label htmlFor="email">{t('auth.email', 'Email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              placeholder={t('auth.email', 'Email')}
              autoComplete="email"
              disabled={isLoading}
            />
          </div>

          <div className="form-field">
            <label htmlFor="password">{t('auth.password')}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder={t('auth.password')}
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>

          <button type="submit" className="btn-login" disabled={isLoading}>
            {isLoading ? t('auth.loggingIn', 'Logging in...') : t('auth.login')}
          </button>

          <div className="login-forgot">
            <a
              href={`mailto:info@default-solutions.it?subject=${encodeURIComponent(t('auth.resetCredentialsSubject'))}&body=${encodeURIComponent(t('auth.resetCredentialsBody', { email: email || '...' }))}`}
            >
              {t('auth.forgotCredentials')}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
